import React from 'react'
import ReactStars from 'react-stars'
import CommentForm from './comment-form'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import './view-text.css'
import { deleteCommentFromApi, sendEditedCommentToApi } from '../actions/comments'

export class ViewEdit extends React.Component {
	constructor(props) {
		super(props)
		this.commentRefs = []
		this.controlRefs = []
		this.submitRefs = []
		
		this.showEditControls = this.showEditControls.bind(this)
		this.deleteComment = this.deleteComment.bind(this)
		this.editComment = this.editComment.bind(this)
	}

	deleteComment(commentId, textId, e) {
		e.preventDefault()
		this.props.dispatch(deleteCommentFromApi(commentId, textId, true))
	}

	showEditControls(i, e) {
		e.preventDefault()
		this.submitRefs[i].classList.toggle('hide')
		this.controlRefs[i].classList.toggle('hide')
	}

	editComment(commentId, editId, i, e) {
		e.preventDefault()
		this.props.dispatch(sendEditedCommentToApi(commentId, editId, this.commentRefs[i].value, true))

		this.submitRefs[i].classList.toggle('hide')
		this.controlRefs[i].classList.toggle('hide')
	}

	render() {
		if(!this.props.uid) {
			return <Redirect to='/' />
		}

		console.log(this.props.allEdits)
		const editData = this.props.allEdits.filter(edit => edit._id === this.props.location.state.editId)[0]

		if(!editData) {
			return <Redirect to={ {
						pathname: '/404/not-found',
						state: { filename: this.props.location.state.editId }
					} } />
		}

		const comments = editData.comments.length ? 
			editData.comments.map((comment, i) => {
				const edit = comment.uid === this.props.uid ?
					<div className='edit-controls' id={ comment._id }>
						<div ref={ input => this.controlRefs[i] = input }>
							<button className='x-button' onClick={ e => this.deleteComment(comment._id, editData._id, e) }>x</button>
							<button className='comment' onClick={ e => this.showEditControls(i, e) }>Edit</button>
						</div>
						<div ref={ input => this.submitRefs[i] = input } className='hide'>
							<textarea className='edit-comment' ref={ input => this.commentRefs[i] = input } defaultValue={ comment.body }/>
							<button className='comment' onClick={ e => this.showEditControls(i, e) }>x</button>
							<button className='comment' onClick={ e => this.editComment(comment._id, editData._id, i, e) }>Submit</button>
						</div>
					</div>
					: <div></div>

				return (
					<div key={ comment._id }>
						<Link to={{
							pathname: `/user/${comment.uid}`,
							state: { userId: comment.uid }
						}}>{ comment.author }</Link>
						<div>{ comment.body }</div>
						<ReactStars name={`comment-${i}`}
							color1='#7103a0'
							color2='#4fff7b'
							count={ 5 }
							value={ comment.rating }
							size={ 12 }
							edit={ false }
						/>
						{ edit }
					</div>
				)
			}) 
		: <div></div>

		return(
			<div className='row'>
				<div className='view-text col-12'>
					<div className='text col-8'>
						<div className='text-body'>
							<h2 >
								<Link to={ {
									pathname: `/user/${ editData.editorId }`,
									state: { userId: editData.editorId}
								} }>{ editData.editorName }</Link>'s edit of <Link to={ {
									pathname: `/user/${ editData.authorId }`,
									state: { userId: editData.editorId }
								} }>{ editData.authorName }</Link>'s paper: <Link to={ {
									pathname: `/text/${ editData.title }`,
									state: { textId: editData.textId }
								} }>{editData.title}
								</Link>
							</h2>
							<p>{ editData.body }</p>
						</div>
					</div>
					<div className='text-info'>
						<div className='col-3'>Editor's Comments:
							<div>{ editData.editorComment }</div>
						</div>
						<div className='comment-container col-3'>Comments:{ comments }</div>
						<CommentForm item={ editData._id } isEdit={ true }/>
					</div>
				</div>
			</div>
		)

	}
}

const mapStateToProps = state => ({
	uid: state.auth.uid,
	allEdits: state.edit.allEdits
})

export default connect(mapStateToProps)(ViewEdit)


// WEBPACK FOOTER //
// ./src/components/view-edit.js